/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";
export const DASHBOARD_USER_DATA = "DASHBOARD_USER_DATA";
export const DASHBOARD_USER_DATA_SUCCESS = "DASHBOARD_USER_DATA_SUCCESS";